import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import CloseHamburgerMenu from "../../assets/CloseIcon.svg";
import LanguageSwitcher from "../LanguageSwitcher";

const HamburgerMenuContainer = styled.div`
  position: absolute;
  z-index: 9999;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background-color: rgba(29, 109, 193, 1);
  transition: all 300ms ease-in-out;
`;
const HamburgerMenuListItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Language = styled.div`
  color: #fff;
  padding-top: 64px;
`;
const HamburgerMenuItems = styled(Link)`
  display: block;
  text-decoration: none;
  color: #fff;
  margin-bottom: 28px;
  font-size: 18px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
  &::after {
    content: "";
    position: absolute;
    height: 3px;
    background-color: #fff;
    width: 0;
    bottom: -3px;
    align-self: center;
    pointer-events: none;
    right: 0;
    transition: all 300ms ease;
  }
  &:hover::after {
    width: 100%;
    left: 0;
  }
`;
const HamburgerMenuItemsMain = styled(Link)`
  display: block;
  text-decoration: none;
  color: #fff;
  margin-bottom: 12px;
  font-size: 22px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
  &::after {
    content: "";
    position: absolute;
    height: 3px;
    background-color: #fff;
    width: 0;
    bottom: -3px;
    align-self: center;
    pointer-events: none;
    right: 0;
    transition: all 300ms ease;
  }
  &:hover::after {
    width: 100%;
    left: 0;
  }
`;

export const HamburgerMenu = ({ setMenuIsOpen, setModalOpen }) => {
  return (
    <HamburgerMenuContainer>
      <HamburgerMenuListItems>
        <HamburgerMenuItems onClick={() => setMenuIsOpen(false)}>
          Home
        </HamburgerMenuItems>
        <HamburgerMenuItems
          onClick={() => setMenuIsOpen(false)}
          as="a"
          href="#services"
        >
          Services
        </HamburgerMenuItems>
        <HamburgerMenuItems
          onClick={() => setMenuIsOpen(false)}
          as="a"
          href="#services"
        >
          Get care
        </HamburgerMenuItems>
        <HamburgerMenuItems
          onClick={() => setMenuIsOpen(false)}
          as="a"
          href="#partnership"
        >
          Partnerships
        </HamburgerMenuItems>
        {/* <HamburgerMenuItems onClick={() => setMenuIsOpen(false)} as="a" href="#services">Blogs</HamburgerMenuItems> */}
        <HamburgerMenuItems
          onClick={() => setMenuIsOpen(false)}
          as="a"
          href="#about-us"
        >
          About us
        </HamburgerMenuItems>

        <HamburgerMenuItemsMain
          onClick={() => {
            setMenuIsOpen(false);
            setModalOpen(true);
          }}
        >
          Join as a Healthcare Practitioner
        </HamburgerMenuItemsMain>
                <Language
          onClick={() => {
            setMenuIsOpen(false);
          }}
        >
          <LanguageSwitcher />
        </Language>
      </HamburgerMenuListItems>
    </HamburgerMenuContainer>
  );
};
